import React from 'react';

function Disclaimer({ className = '' }) {
  return (
    <div
      className={`bg-gray-800 text-gray-200 p-4 md:p-6 rounded-lg shadow-md border border-gray-700 ${className}`}
    >
      <p className="text-sm md:text-base leading-relaxed">
        <strong>Disclaimer:</strong>
        <br />
        The resources on this website are primarily created by students. While we aim for high
        quality, we cannot guarantee accuracy or completeness. Users should evaluate materials
        critically and use them at their own discretion. Neither the founders nor North-West
        University are responsible for any errors, omissions, or outcomes resulting from using
        this content.
      </p>
    </div>
  );
}

export default Disclaimer;
